module.exports = __webpack_public_path__ + "img/cr.8490d149.jpg";